import styled from 'styled-components';
import { ReactComponent as RawCompetitorsSVG } from '../../../../assets/icons/icon-competitors.svg';

export const IconCompetitors = styled(RawCompetitorsSVG)``;
